export type ProductIconEntry = {
  name: string;
  colorClass: string;
  subtitle: string;
  iconKey: "Protocol" | "Client" | "Caller" | "Responder" | "Platform" | "Selfhost";
};

export const productIcons: ProductIconEntry[] = [
  { name: "Protocol", colorClass: "text-[#A3E635]", subtitle: "代码合约 / 规范协议", iconKey: "Protocol" },
  { name: "Client", colorClass: "text-[#3B82F6]", subtitle: "操作界面 / 交互入口", iconKey: "Client" },
  { name: "Caller", colorClass: "text-[#14B8A6]", subtitle: "起始节点 / 抛出请求", iconKey: "Caller" },
  { name: "Responder", colorClass: "text-[#F97316]", subtitle: "目标节点 / 被动调用", iconKey: "Responder" },
  { name: "Platform", colorClass: "text-[#8B5CF6]", subtitle: "基础设施 / 层叠平台", iconKey: "Platform" },
  { name: "Selfhost", colorClass: "text-[#FACC15]", subtitle: "私有部署 / 服务器锁", iconKey: "Selfhost" },
];

export const brandIconSizes = [
  { size: "w-48 h-48", border: "border-4 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]", label: "192 × 192" },
  { size: "w-24 h-24", border: "border-4 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]", label: "96 × 96" },
  { size: "w-12 h-12", border: "border-2 border-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]", label: "48 × 48" },
  { size: "w-8 h-8", border: "border-2 border-black", label: "32 × 32" },
];
